import { useQuery } from "react-query";
import API from "../../../services/API";

export default function useCategories(){

    return useQuery({

        queryKey: ['apply', 'categories'],

        queryFn: () => API.get(`/categories`).then(r => r.data),

    })
}